import { Step, StepLabel, Stepper } from "@mui/material";
import { Fragment } from 'react';
import { Grid, Layout, Loader, Paper, Typography } from "../../../components";
import { CreateAccountModal } from "../create-account-modal";
import StepNavigation from "../form-step-navigation";
import { useCreateAccountData } from "../hooks/useCreateAccountData";
import { useNewBidData } from "../hooks/useNewBidData";
import { NewBidFormStepOne } from "../new-bid-form-step-one";
import { NewBidFormStepThree } from "../new-bid-form-step-three";
import { NewBidFormStepTwo } from "../new-bid-form-step-two";

export const NewBid = () => {
  const {
    accountOptions,
    accounts,
    activeStep,
    bid,
    createAccountModalVisibilityControls,
    createAccountModalVisibility,
    dashboard,
    formik,
    programPriceSettings,
    programs,
    setActiveStep,
    refetchAccounts
  } = useNewBidData()

  const {
    account, 
    createAccountFormik, 
  } = useCreateAccountData({ formik, programs: programs.data, createAccountModalVisibilityControls, refetchAccounts });

  const formSteps = ["Programa e Conta", "Quantidade de Milhas e Valor", "Revisão"];

  const renderStepForm = (step: number) => {
    const stepProps = { formik, programPriceSettings, programs: programs.data };
  
    switch (step) {
      case 1:
        return <NewBidFormStepOne {...stepProps} accountOptions={accountOptions} createAccountModalVisibilityControls={createAccountModalVisibilityControls} />;
      case 2:
        return <NewBidFormStepTwo {...stepProps} dashboardData={dashboard.data} createAccountFormik={createAccountFormik}/>;
      case 3:
        return <NewBidFormStepThree formik={formik} />;
      default:
        return null;
    }
  };

  return (
    <Fragment>
      <Layout>
        <Grid container justifyContent="center" minHeight="calc(100vh - 64px)" alignItems="center" padding={3} spacing={2}>
          {(bid.loading || dashboard.loading || programs.loading || accounts.loading) ? (
            <Loader />
          ) : (
            <Grid container direction={{ lg: 'row', xs: 'column' }} spacing={2} justifyContent="center" alignItems="center" marginTop={2}>
              <Grid item xs={12} sm={6}>
                <Paper elevation={1}>
                  <form onSubmit={formik.handleSubmit}>
                    <Typography variant="h5" textAlign="center" marginBottom={2}>Nova Oferta</Typography>
                    <Stepper activeStep={activeStep - 1} alternativeLabel>
                      {formSteps.map((label) => (
                        <Step key={label}><StepLabel>{label}</StepLabel></Step>
                      ))}
                    </Stepper>
                    <Grid container padding={2} rowSpacing={2} justifyContent="center">
                        
                      {renderStepForm(activeStep)}

                        <StepNavigation 
                          activeStep={activeStep} 
                          formSteps={formSteps} 
                          formik={formik} 
                          loading={bid.loading || account.loading || dashboard.loading || programs.loading} 
                          setActiveStep={setActiveStep}
                        />
  
                    </Grid>
                  </form>
                </Paper>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Layout>

      <CreateAccountModal
        accountLoading={account.loading}
        formik={createAccountFormik}
        isModalOpen={createAccountModalVisibility} 
        modalVisibilityControls={createAccountModalVisibilityControls}
      />
    </Fragment>
  );
};

export default NewBid;
